import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsCommands } from "../../shared/dto/aps.commands";
import * as angular from 'angular';
import HttpServiceName, { HttpService } from "../http/http.service";
import { Endpoints } from "../../shared/config/constant.module";
import * as _ from "lodash";

export interface TiamaDefectMappingService {
  addTiamaDefectMapping: (tiamaDefect: apsViewModels.TiamaDefectMappingItem) => angular.IPromise<any>;
  updateTiamaDefectMapping: (tiamaDefect: apsViewModels.TiamaDefectMappingItem) => angular.IPromise<any>;
  getTiamaDefectMappings(): angular.IPromise<apsViewModels.TiamaDefectMappingItem[]>;
  getTiamaDefectMapping: (tiamaDefectId: string) => angular.IPromise<apsViewModels.TiamaDefectMappingItem>;
}

export default angular.module('aps.services.tiamaDefectMapping', [HttpServiceName])
  .service('tiamaDefectMappingService', function (httpService: HttpService): TiamaDefectMappingService {

    function addTiamaDefectMapping(tiamaDefect: apsViewModels.TiamaDefectMappingItem) {
      return httpService.post(Endpoints.TIAMA_DEFECT_MAPPINGS_ADD, tiamaDefect);
    }

    function updateTiamaDefectMapping(tiamaDefect: apsViewModels.TiamaDefectMappingItem) {
      let url = Endpoints.TIAMA_DEFECT_MAPPINGS_DETAIL.replace('{0}', tiamaDefect.id);
      return httpService.post(url, tiamaDefect);
    }

    function getTiamaDefectMappings() {
      return httpService.get<apsViewModels.TiamaDefectMappingItem[]>(Endpoints.TIAMA_DEFECT_MAPPINGS);
    }

    function getTiamaDefectMapping(tiamaDefectId: string) {
      let url = Endpoints.TIAMA_DEFECT_MAPPINGS_DETAIL.replace('{0}', tiamaDefectId);
      return httpService.get<apsViewModels.TiamaDefectMappingItem>(url);
    }

    return {
      addTiamaDefectMapping: addTiamaDefectMapping,
      updateTiamaDefectMapping: updateTiamaDefectMapping,
      getTiamaDefectMappings: getTiamaDefectMappings,
      getTiamaDefectMapping: getTiamaDefectMapping
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/services/defects/tiamaDefectMapping.service.ts